import { message } from "antd";
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from "../axios";

export const findBusiness = async () => {
  try {
    const res = await axiosGet({
      path: "business-type/list",
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const addBusinessLocation = async (payload) => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosPost({
      path: `business/add-business-location?userId=${uId}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const updateBusinessLocation = async (payload) => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosPatch({
      path: `business/update-location?userId=${uId}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const deleteBusinessLocation = async (id) => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosDelete({
      path: `business/delete-location/${id}?userId=${uId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const getBusiness = async () => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosGet({
      path: `business?userId=${uId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getBusinessLocations = async () => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosGet({
      path: `business/locations?userId=${uId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getUser = async () => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosGet({
      path: `user?userId=${uId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getTeamMembers = async () => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosGet({
      path: `business/team-members?userId=${uId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const deleteTeamMembers = async (id) => {
  try {
    const res = await axiosDelete({
      path: `user/delete-member/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getAnalytics = async () => {
  try {
    const businessId = localStorage.getItem("businessId")
    const userId = localStorage.getItem("userId")
    const res = await axiosGet({
      path: businessId ? `analytics?businessId=${businessId}&userId=${userId}` : `analytics`,
    });
    return res;
  } catch (e) {
    message.error(e?.response?.data?.message);
  }
};
export const getAnalyticsByDate = async (date) => {
  try {
    const businessId = localStorage.getItem("businessId")
    const userId = localStorage.getItem("userId")
    const res = await axiosGet({
      path: `analytics/orders?type=${date}&businessId=${businessId}&userId=${userId}`,
    });
    return res;
  } catch (e) {
    message.error(e?.response?.data?.message);
  }
};
export const getPercentageAnalytics = async (filter) => {
  try {
    const businessId = localStorage.getItem("businessId")
    const userId = localStorage.getItem("userId")
    const res = await axiosGet({
      path: `analytics/percentage?filter=${filter}&businessId=${businessId}&userId=${userId}`,
    });
    return res;
  } catch (e) {
    message.error(e?.response?.data?.message);
  }
};

export const enableBusinessMessages = async (id, payload) => {
  try {
    const businessId = localStorage.getItem("businessId")

    const res = await axiosPatch({
      path: `business/enable-messages/${id}`,
      payload
    });
    return res;
  } catch (e) {
    message.error(e?.response?.data?.message);
  }
}
